import React from 'react';
import { describeTimezoneScope } from '../summaryFormatters';

/**
 * Дополнение к ТЗ №1 §3: подпись обязана следовать backend timezone metadata
 * (timezone_mode / display_timezone / display_timezones). Переиспользуется
 * в Operational Issues и списке событий.
 */
const TimezoneNotice = ({ scope, className = '' }) => {
  const { text, title } = describeTimezoneScope(scope);
  if (!text) return null;
  return <span className={`sum-tz ${className}`.trim()} title={title || undefined}>{text}</span>;
};

export default TimezoneNotice;
